import { mapGetters } from 'vuex'
export var imageMixin = {
  data () {
    return {
      imageIndex: 0,
      imageUrl: ''
    }
  },
  created () {
    this.imageUrl = this.images[0].url
  },
  computed: {
    ...mapGetters('booking', [
      'images',
      'appControl'
    ])
  },
  watch: {
    imageUrl () {
      let that = this
      this.imageIndex++
      this.imageIndex = this.imageIndex < this.images.length ? this.imageIndex : 0
      setTimeout(function () {
        that.imageUrl = that.images[that.imageIndex].url
      }, this.appControl.timeouts.imageChange)
    }
  }
}
